module.exports = __webpack_public_path__ + "img/3D-2BHK-t3.735ed806.png";